(() => {
  const timezone = 'America/New_York';

  function computeTimeParts() {
    const now = new Date();
    const cbday = now.toLocaleDateString('en-EN', { weekday: 'long', timeZone: timezone });
    const cbhour = Number(now.toLocaleString('en-GB', { hour: 'numeric', timeZone: timezone }));
    const cbminute = Number(now.toLocaleString('en-GB', { minute: 'numeric', timeZone: timezone }));
    return { cbday, cbhour, cbminute };
  }

  function setSessionVars() {
    try {
      const { cbday, cbhour, cbminute } = computeTimeParts();
      if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
        console.log('set_session_variables', {
          Day: cbday,
          Hour: cbhour,
          Minutes: cbminute
        });
        window.LiveChatWidget.call('set_session_variables', {
          Day: cbday,
          Hour: cbhour,
          Minutes: cbminute
        });
      }
    } catch (err) {
      // Silently ignore
    }
  }

  function onReady() {
    setSessionVars();
  }

  function attachWhenReady(lcw) {
    try {
      if (lcw && typeof lcw.on === 'function') {
        lcw.on('ready', onReady);
      }
    } catch (err) {
      // Silently ignore
    }
  }

  if (window.LiveChatWidget && typeof window.LiveChatWidget.on === 'function') {
    attachWhenReady(window.LiveChatWidget);
  } else {
    const start = Date.now();
    const interval = setInterval(function() {
      if (window.LiveChatWidget && typeof window.LiveChatWidget.on === 'function') {
        clearInterval(interval);
        attachWhenReady(window.LiveChatWidget);
      } else if (Date.now() - start > 30000) {
        clearInterval(interval);
      }
    }, 250);
  }
})();


